<!-- No title — the tenant-detail shell above the tab strip names the page. -->
<app-grid-page>
  <app-grid
    [columns]="columns()"
    [data]="users()"
    [rowId]="userId"
    [loading]="isLoading()"
    [page]="page()"
    [pageSize]="size()"
    [totalElements]="totalElements()"
    [totalPages]="totalPages()"
    [searchable]="true"
    [rowActions]="rowActions()"
    (searchChange)="onSearchChange($event)"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (rowClick)="onRowClick(asUser($event))"
    (rowActionClick)="onRowAction($event.actionId, asUser($event.row))"
  >
  </app-grid>
</app-grid-page>
